import {FaCarCrash, FaDiscord} from 'react-icons/fa';
import { FaUserShield, FaTruckMedical, FaScrewdriverWrench } from 'react-icons/fa6';
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import orange_banner from '../assets/orange_banner.png';
import char1 from '../assets/char1.png';
import char2 from '../assets/char2.png';
import lexikonn from  '../assets/lexikonn.png';
import DiscordMembers from './DiscordMembers';
import Rules from './Rules';

export default function Sections() {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);


    return (
        <div>
            <section className="relative min-h-screen bg-black flex items-center justify-center text-center pt-24 px-6 overflow-hidden">
                <div className="z-10">
                    <h1
                        className="text-5xl md:text-6xl font-extrabold text-orange-500 mb-4 tracking-widest"
                        data-aos="fade-up"
                    >
                        RPČKO.EU
                    </h1>
                    <p
                        className="text-lg md:text-xl text-gray-300 mb-8"
                        data-aos="fade-up"
                        data-aos-delay="200"
                    >
                        Kde je svět ještě v pořádku.
                    </p>
                    <a
                        href="https://discord.gg/VbKJks6cYG"
                        data-aos="fade-up"
                        data-aos-delay="400"
                        className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-bold px-6 py-3 rounded-lg transition duration-300 shadow-lg"
                    >
                        <FaDiscord className="text-xl" />
                        Přidat se
                    </a>
                </div>

                <img
                    src={orange_banner}
                    alt="Banner"
                    data-aos="fade-left"
                    data-aos-duration="2500"
                    className="absolute bottom-0 right-0 w-80 md:w-[44rem] lg:w-[48rem] drop-shadow-[0_0_40px_rgba(255,165,0,0.4)] z-0"
                />
                <img
                    src={char1}
                    alt="Postava"
                    data-aos="fade-left"
                    data-aos-duration="800"
                    className="absolute bottom-0 right-6 w-48 md:w-64 lg:w-72 drop-shadow-[0_0_20px_rgba(0,0,0,0.5)] z-10"
                />

            </section>

            <section
                data-aos="fade-right"
                className="min-h-screen bg-[#111] text-white flex flex-col justify-center px-6 py-20"
            >
                <h2 className="text-4xl font-bold text-orange-500 mb-12 text-center">
                    O serveru
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-6xl mx-auto z-10">
                    <div className="flex gap-4 items-start">
                        <div className="w-2 h-full bg-orange-500 rounded" />
                        <div>
                            <h3 className="text-xl font-semibold mb-2">Profesionální přístup</h3>
                            <p className="text-gray-400">
                                Administrátoři i frakce dbají na atmosféru a férový přístup ke každému hráči.
                            </p>
                        </div>
                    </div>

                    <div className="flex gap-4 items-start">
                        <div className="w-2 h-full bg-orange-500 rounded" />
                        <div>
                            <h3 className="text-xl font-semibold mb-2">Silná komunita</h3>
                            <p className="text-gray-400">
                                Aktivní Discord, denní RP, přátelská komunita. Nováčci vítáni.
                            </p>
                        </div>
                    </div>

                    <div className="flex gap-4 items-start">
                        <div className="w-2 h-full bg-orange-500 rounded" />
                        <div>
                            <h3 className="text-xl font-semibold mb-2">Vlastní skripty</h3>
                            <p className="text-gray-400">
                                Unikátní skripty a UI přizpůsobené potřebám RP a výkonu.
                            </p>
                        </div>
                    </div>

                    <div className="flex gap-4 items-start">
                        <div className="w-2 h-full bg-orange-500 rounded" />
                        <div>
                            <h3 className="text-xl font-semibold mb-2">Rozmanité prostředí</h3>
                            <p className="text-gray-400">
                                LS i Blaine County ožívají s každým RP scénářem, eventy i random situacemi.
                            </p>
                        </div>
                    </div>
                </div>
                <img
                    src={char2}
                    alt="Postava"
                    data-aos="fade-right"
                    className="absolute bottom-0 left-0 w-48 md:w-64 lg:w-72 drop-shadow-[0_0_20px_rgba(0,0,0,0.5)] z-0 opacity-60 pointer-events-none"
                />
            </section>
            <section
                data-aos="fade-up"
                className="min-h-screen bg-[#0d0d0d] text-white flex flex-col justify-center px-6 py-24"
            >
                <h2 className="text-4xl font-bold text-orange-500 mb-16 text-center">Frakce</h2>

                <div className="space-y-10 max-w-4xl mx-auto">

                    <div className="flex items-center gap-6" data-aos="fade-right">
                        <FaUserShield className="text-4xl text-blue-400" />
                        <div>
                            <h3 className="text-xl font-semibold text-white">Los Santos Police Department</h3>
                            <p className="text-gray-400">Ochraňuj zákon, vyšetřuj zločiny a zajišťuj pořádek v ulicích Los Santos.</p>
                        </div>
                    </div>

                    <div className="flex items-center gap-6" data-aos="fade-left" data-aos-delay="100">
                        <FaTruckMedical className="text-4xl text-red-400" />
                        <div>
                            <h3 className="text-xl font-semibold text-white">EMS – Záchranná služba</h3>
                            <p className="text-gray-400">Zachraňuj životy, reaguj na výjezdy a buď oporou města v nouzi.</p>
                        </div>
                    </div>

                    <div className="flex items-center gap-6" data-aos="fade-right" data-aos-delay="200">
                        <FaScrewdriverWrench className="text-4xl text-yellow-400" />
                        <div>
                            <h3 className="text-xl font-semibold text-white">Mechanici / Tuning crew</h3>
                            <p className="text-gray-400">Opravuj, vylepšuj a buduj technické zázemí města.</p>
                        </div>
                    </div>

                    <div className="flex items-center gap-6" data-aos="fade-left" data-aos-delay="300">
                        <FaCarCrash className="text-4xl text-purple-400" />
                        <div>
                            <h3 className="text-xl font-semibold text-white">Mafie / Gangy</h3>
                            <p className="text-gray-400">Získej vliv v podsvětí, obchoduj, plánuj akce a kontroluj teritorium.</p>
                        </div>
                    </div>

                </div>
                <img
                    src={char1}
                    alt="Postava"
                    data-aos="fade-left"
                    data-aos-duration="800"
                    className="absolute bottom-0 right-6 w-48 md:w-64 lg:w-72 drop-shadow-[0_0_20px_rgba(0,0,0,0.5)] z-10"
                />
            </section>

            <Rules/>

            <DiscordMembers/>
            <footer>
                <div className="footer-link" onClick={() => window.open('https://lexikonn.eu', '_blank')}>
                    <img src={lexikonn} alt="Lexikonn Logo" />
                    <span>Created by Lexikonn.eu</span>
                </div>
            </footer>
        </div>
    );
}
